import { render, staticRenderFns } from "./users-invites-confirmation.vue?vue&type=template&id=13253b6e&"
import script from "./users-invites-confirmation.vue?vue&type=script&lang=js&"
export * from "./users-invites-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports